
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire4b75"];
var parcelRegister = parcelRequire.register;
parcelRegister("kjTLP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $4ed7e7d0529fe41f$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $lp3dk = parcelRequire("lp3dk");

var $88FA0 = parcelRequire("88FA0");

var $duLFK = parcelRequire("duLFK");

var $bcbvQ = parcelRequire("bcbvQ");

var $jlTfJ = parcelRequire("jlTfJ");

var $4r4cM = parcelRequire("4r4cM");

var $1qZrx = parcelRequire("1qZrx");
const $4ed7e7d0529fe41f$var$HOME_SLUG = "home";
const $4ed7e7d0529fe41f$var$HOME_NOT_LOGGED_IN_SLUG = "home-not-logged-in";
const $4ed7e7d0529fe41f$var$Home = ()=>{
    const isLoggedIn = (0, $bcbvQ.default).isLoggedIn();
    if ((0, $duLFK.isWaitingForData)((0, $jlTfJ.default).urlData) || (0, $duLFK.isDefaultData)((0, $jlTfJ.default).urlData)) return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        "data-testid": "home-skeleton",
        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $88FA0.default), {
            height: 500
        })
    });
    if ((0, $duLFK.isDataAvailable)((0, $jlTfJ.default).urlData)) {
        const urlDataHomeLoggedIn = (0, $jlTfJ.default).urlData.data.find((data)=>data.slug === $4ed7e7d0529fe41f$var$HOME_SLUG);
        const urlDataHomeNotLoggedIn = (0, $jlTfJ.default).urlData.data.find((data)=>data.slug === $4ed7e7d0529fe41f$var$HOME_NOT_LOGGED_IN_SLUG);
        // TODO: Add some error handling for the not-logged-in-page after the article published in production
        if (!urlDataHomeLoggedIn) return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $4r4cM.default), {
            showCloseButton: false,
            gaErrorTracking: {
                context: "home",
                text: "content_not_found_error"
            },
            children: [
                "Fant ikke innholdet med slug '",
                $4ed7e7d0529fe41f$var$HOME_SLUG,
                "'"
            ]
        });
        if (!isLoggedIn && urlDataHomeNotLoggedIn) return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
            className: "-tw-mt-8",
            children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $1qZrx.default), {
                id: urlDataHomeNotLoggedIn.id
            })
        });
        return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $1qZrx.default), {
            id: urlDataHomeLoggedIn.id
        });
    }
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $4r4cM.default), {
        showCloseButton: false,
        gaErrorTracking: {
            context: "home",
            text: "loading_error"
        },
        children: "Det oppsto en uventet feil under lasting av forsiden"
    });
};
var $4ed7e7d0529fe41f$export$2e2bcd8739ae039 = (0, $lp3dk.view)($4ed7e7d0529fe41f$var$Home);

});


//# sourceMappingURL=Home.8686bd5b.js.map
